import { mapActions, mapMutations, mapState } from 'vuex';
import request from '@/utils/api/request';
import CreateModal from '@/containers/tenders/CreateModal';
import get from 'lodash.get';

const editTender = {
  computed: {
    ...mapState('global', ['currentProject']),
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('global', ['changeCurrentProject']),
    ...mapMutations('tenderEdit', ['setTender']),
    async editTender(tenderId, step = 1, project = null) {
      if (project) this.changeCurrentProject(project);
      const [tender, rows] = await Promise.all([
        request.get(`/tenders/${tenderId}/`),
        request.get(`/tenders/${tenderId}/row_ids/`),
      ]);

      this.setTender({
        ...tender.data,
        row_ids: rows.data,
        contact_person_responsible_user_id:
          tender.data.contact_person_responsible_user.id || this.user?.id,
        file_ids: tender.data.files.map((file) => file.id),
      });

      this.openModal({
        component: CreateModal,
        context: {
          team: get(this.currentProject, 'team', []),
          attributes: {
            class: ['create-tender__container'],
          },
          step,
        },
      });
    },
  },
};

export default editTender;
